"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const paper_1 = __importDefault(require("../../elements/paper"));
const typography_1 = __importDefault(require("../../elements/typography"));
const pd_logo_small_svg_1 = __importDefault(require("../../../assets/icons/pd_logo_small.svg"));
const AuthTemplate = (props) => {
    const { quote, authorOrRole, description, backgroundImage, highlightLogin, highlightRegister, linkComponent, loginLink, loginLinkTitle = "Login", registerLink, registerLinkTitle = "Register", message, children, } = props;
    return (react_1.default.createElement(material_1.Box, { sx: { display: "flex", justifyContent: "flex-end" } },
        react_1.default.createElement(material_1.Box, { sx: {
                position: "fixed",
                left: 0,
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100vh",
                width: "50%",
                display: { xs: "none", md: "flex" },
                "&:before": {
                    content: "''",
                    position: "absolute",
                    zIndex: 1,
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: "linear-gradient(to bottom,rgba(255, 255, 255, 0), rgba(0, 0, 0,0.7))",
                },
            } },
            backgroundImage,
            quote && (react_1.default.createElement(typography_1.default, { variant: "h4", sx: {
                    lineHeight: "1.7rem",
                    fontWeight: "bold",
                    position: "absolute",
                    bottom: { xs: "150px", xl: "260px" },
                    maxWidth: { xs: "385px", xl: "390px" },
                    width: { xs: "100%", md: "70%", lg: "50%" },
                    textAlign: "center",
                    zIndex: 2,
                } },
                "\"",
                quote,
                "\"")),
            (authorOrRole || description) && (react_1.default.createElement(material_1.Box, { sx: {
                    position: "absolute",
                    left: { xs: "50px", xl: "70px" },
                    bottom: { xs: "50px", xl: "70px" },
                    zIndex: 2,
                } },
                authorOrRole && react_1.default.createElement(typography_1.default, { variant: "body2" }, authorOrRole),
                description && react_1.default.createElement(typography_1.default, { variant: "subtitle1" }, description)))),
        react_1.default.createElement(material_1.Box, { sx: {
                minHeight: "100vh",
                width: { xs: "100%", md: "50%" },
                display: "flex",
                alignItems: "center",
                py: 4,
            } },
            react_1.default.createElement(material_1.Container, { maxWidth: "sm" },
                react_1.default.createElement(material_1.Box, { sx: { width: "100%", display: "flex", justifyContent: "center" }, mb: 3 },
                    react_1.default.createElement(pd_logo_small_svg_1.default, { height: 50 })),
                react_1.default.createElement(paper_1.default, { sx: { pt: (loginLink || registerLink) && "0 !important" } },
                    (loginLink || registerLink) && (react_1.default.createElement(material_1.Box, { sx: {
                            py: 2,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        } },
                        loginLink && (react_1.default.createElement(material_1.Link, { component: linkComponent, variant: "button", href: loginLink, sx: { color: highlightLogin ? colors_1.default.primary : colors_1.default.text[100] }, underline: "hover" }, loginLinkTitle)),
                        loginLink && registerLink && react_1.default.createElement(typography_1.default, { variant: "button" }, "\u00A0\u00A0|\u00A0\u00A0"),
                        registerLink && (react_1.default.createElement(material_1.Link, { component: linkComponent, variant: "button", href: registerLink, sx: { color: highlightRegister ? colors_1.default.primary : colors_1.default.text[100] }, underline: "hover" }, registerLinkTitle)))),
                    react_1.default.createElement(paper_1.default, { backgroundDark: false, level: 2 },
                        message && (react_1.default.createElement(typography_1.default, { variant: "h3", sx: { mt: 1, mb: 4, textAlign: "center" } }, message)),
                        children))))));
};
exports.default = AuthTemplate;
